import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import attendance from './attendance';
import benefits from './benefits';
import bugReports from './bugReports';
import dbds from './dbds';
import fleet from './fleet';
import dialogs from './dialogs';
import lines from './lines';
import profiles from './profiles';
import lots from './lots';
import operators from './operators';
import transportOperators from './transportOperators';
import supervisorsGroups from './supervisorsGroups';
import users from './users';
import snackbars from './snackbars';
import schemas from './schemas';
import sections from './sections';
import stops from './stops';
import employees from './employees';
import employeesSales from './employeesSales';
import companies from './companies';
import collaborators from './collaborators';
import orders from './orders';
import ordersSchool from './ordersSchool';
import schoolSettings from './schoolSettings';
import collaboratorsGroups from './collaboratorsGroups';
import transportCards from './transportCards';
import denylist from './denylist';
import userProfile from './userProfile';
import reports from './reports';
import fares from './fares';
import utils from './utils';
import schools from './schools';
import serviceDiscovery from './serviceDiscovery';
import students from './students';
import itineraries from './itineraries';
import garage from './garage';
import sellingPoints from './sellingPoints';
import sellingTerminals from './sellingTerminals';
import trips from './trips';
import drawer from './drawer';
import collapse from './collapse';
import terminals from './terminals';
import terminalBlocks from './terminalBlocks';
import userIps from './userIps';
import modalFilter from './modalFilter';
import groupingModal from './groupingModal';
import searchs from './searchs';
import appBar from './appBar';
import listingDrawer from './listingDrawer';
import layout from './layout';
import routes from './routes';
import facial from './facial';
import wallet from './wallet';
import devices from './devices';
import elementRef from './elementRef';
import supervisors from './supervisors';
import transportCardsPlace from './transportCardsPlace';
import dates from './dates';
import lineLot from './lineLot';
import printModel from './printModel';
import tolls from './tolls';
import integrationFence from './integrationFence';
import schedulesMatrix from './schedulesMatrix';
import pointsList from './pointsList';
import audio from './audio';
import linesMatrixIntegration from './linesMatrixIntegration';
import companyUsers from './companyUsers';
import companyReport from './company';
import appUserMerge from './appUserMerge';
import lastVersion from './lastVersion';
import localLimit from './localLimit';
import notifications from './notifications';
import segmentations from './segmentations';
import voucher from './voucher';
import balance from './balance';
import turnstiles from './turnstiles';
import product from './product';
import fareBonus from './fareBonus';
import fareTax from './fareTax';
import currentModule from './currentModule';
import synoptic from './synoptic';
import tax from './tax';
import schedule from './schedule';
import publicStore from './publicStore';
import plantas from './plantas';

const createRootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    attendance,
    benefits,
    bugReports,
    fleet,
    dialogs,
    dbds,
    itineraries,
    lines,
    profiles,
    lots,
    operators,
    transportOperators,
    supervisorsGroups,
    users,
    snackbars,
    schemas,
    sections,
    stops,
    employees,
    transportCards,
    denylist,
    userProfile,
    reports,
    fares,
    utils,
    companies,
    collaborators,
    orders,
    ordersSchool,
    schoolSettings,
    collaboratorsGroups,
    schools,
    serviceDiscovery,
    students,
    garage,
    sellingPoints,
    sellingTerminals,
    trips,
    drawer,
    employeesSales,
    collapse,
    terminals,
    terminalBlocks,
    userIps,
    modalFilter,
    groupingModal,
    searchs,
    appBar,
    listingDrawer,
    printModel,
    layout,
    routes,
    facial,
    wallet,
    devices,
    elementRef,
    supervisors,
    transportCardsPlace,
    dates,
    lineLot,
    tolls,
    integrationFence,
    schedulesMatrix,
    pointsList,
    audio,
    linesMatrixIntegration,
    companyUsers,
    companyReport,
    appUserMerge,
    lastVersion,
    localLimit,
    notifications,
    segmentations,
    voucher,
    balance,
    turnstiles,
    product,
    fareBonus,
    fareTax,
    currentModule,
    synoptic,
    tax,
    schedule,
    publicStore,
    plantas,
  });

export default createRootReducer;
